import { makeStyles } from '@material-ui/core/styles'

export const virtualBoreholeInfoStyle = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(4)
  },
  nestedListSubheader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.geoColors.headerText.main,
    userSelect: 'none',
    zIndex: 0
  },
  nestedListSubheaderIcon: {
    float: 'right',
    paddingTop: '0.5rem'
  },
  figure: {
    display: 'flex'
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    fontSize: '0.8rem',
    color: theme.palette.geoColors.text.light
  },
  noBoreholes: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    fontWeight: 500,
    color: theme.palette.geoColors.text.light,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontSize: '0.8rem',
    textAlign: 'center'
  }
}))
